import BannerPlace from './BannerPlace';
import ProductCategory from './ProductCategory';
import PaymentMethod from './PaymentMethod';
import ShippingMethod from './ShippingMethod';
import { Permissions } from '@root/utils/Auth';
import { NavLink } from '@components/Navigation';
import Timetable from './Timetable';
import User from './User';
import Banner from './Banner';
import ProductListAd from './ProductListAd';
import PromotionCategory from './PromotionCategory';
import AdminUser from './AdminUser';
import Product from './Product';
import Cms from './Cms';
import UrlAlias from './UrlAlias';
import ProductAttribute from './ProductAttribute';
import Order from './Order';
import Dashboard from './Dashboard';
import Coupon from './Coupon';
import Donation from "./Donation";

interface ModulConfigType {
    translations: {
        [key: string]: string;
    };
    paths: {
        [key: string]: string;
    };
    menu: NavLink[];
}

const ModuleConfig: ModulConfigType = {
    translations: {
        ...Dashboard.translations,
        ...ProductCategory.translations,
        ...PromotionCategory.translations,
        ...PaymentMethod.translations,
        ...ShippingMethod.translations,
        ...BannerPlace.translations,
        ...Banner.translations,
        ...ProductListAd.translations,
        ...Timetable.translations,
        ...User.translations,
        ...AdminUser.translations,
        ...Product.translations,
        ...Donation.translations,
        ...Cms.translations,
        ...UrlAlias.translations,
        ...ProductAttribute.translations,
        ...Order.translations,
        ...Coupon.translations,
    },
    paths: {
        ...Dashboard.paths,
        ...ProductCategory.paths,
        ...PromotionCategory.paths,
        ...PaymentMethod.paths,
        ...ShippingMethod.paths,
        ...BannerPlace.paths,
        ...Banner.paths,
        ...ProductListAd.translations,
        ...Timetable.paths,
        ...User.paths,
        ...AdminUser.paths,
        ...Product.paths,
        ...Donation.paths,
        ...Cms.paths,
        ...UrlAlias.paths,
        ...ProductAttribute.paths,
        ...Order.paths,
        ...Coupon.paths,
    },
    menu: [
        { label: Dashboard.name, path: Dashboard.paths.dashboard, icon: Dashboard.icon, roles: [] },
        { label: Order.name, path: Order.paths.order, icon: Order.icon, roles: [Permissions.orders] },
        { label: 'users', path: '/users', icon: User.icon, subMenus: [
            { label: User.name, path: User.paths.user, icon: User.icon, roles: [Permissions.users] },
            { label: AdminUser.name, path: AdminUser.paths.adminUser, icon: AdminUser.icon, roles: [Permissions.admins] },
        ]},
        { label: 'products', path: '/products', icon: Product.icon, subMenus: [
            { label: Product.name, path: Product.paths.product, icon: Product.icon, roles: [Permissions.products] },
            { label: ProductAttribute.name, path: ProductAttribute.paths.productAttribute, icon: ProductAttribute.icon, roles: [Permissions.productAttributes] },
            { label: ProductCategory.name, path: ProductCategory.paths.productCategory, icon: ProductCategory.icon, roles: [Permissions.productCategories] },
        ]},
        { label: Donation.name, path: Donation.paths.donation, icon: Donation.icon, roles: [Permissions.donations] },
        { label: Coupon.name, path: Coupon.paths.coupon, icon: Coupon.icon, roles: [Permissions.coupons] },
        { label: PromotionCategory.name, path: PromotionCategory.paths.promotionCategory, icon: PromotionCategory.icon, roles: [Permissions.productCategories] },
        { label: 'banners', path: '/banners', icon: Banner.icon, subMenus: [
            { label: Banner.name, path: Banner.paths.banner, icon: Banner.icon, roles: [Permissions.banners] },
            { label: BannerPlace.name, path: BannerPlace.paths.bannerPlace, icon: BannerPlace.icon, roles: [Permissions.banners] },
            { label: ProductListAd.name, path: ProductListAd.paths.productListAd, icon: ProductListAd.icon, roles: [Permissions.productListAds] },
        ]},
        { label: Cms.name, path: Cms.paths.cms, icon: Cms.icon, roles: [Permissions.cms] },
        { label: 'shipping', path: '/shipping', icon: ShippingMethod.icon, subMenus: [
            { label: ShippingMethod.name, path: ShippingMethod.paths.shippingMethod, icon: ShippingMethod.icon, roles: [Permissions.shipping] },
            { label: Timetable.name, path: Timetable.paths.timetable, icon: Timetable.icon, roles: [Permissions.timetables] },
        ]},
        { label: PaymentMethod.name, path: PaymentMethod.paths.paymentMethod, icon: PaymentMethod.icon, roles: [Permissions.payments] },
        { label: UrlAlias.name, path: UrlAlias.paths.urlAlias, icon: UrlAlias.icon, roles: [Permissions.urlAliases] },
    ],
};

export default ModuleConfig;



// WEBPACK FOOTER //
// ./src/modules/ModuleConfig.ts